export class EuiUploadedFile {
    name: string;
    url: string;
    size: number;
    type: string;

    constructor(values: Object = {}) {
        Object.assign(this, values);
    }
}
